import { isEqual } from 'lodash';
import React from 'react';
function checkDeps(deps) {
    if (!deps || !deps.length) {
        throw new Error('useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.');
    }
    if (deps.every(isPrimitive)) {
        throw new Error('useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.');
    }
}
function isPrimitive(val) {
    return val == null || /^[sbn]/.test(typeof val);
}
function useDeepCompareMemoize(value) {
    var ref = React.useRef();
    if (!isEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
export function useDeepCompareEffect(callback, dependencies) {
    if (process.env.NODE_ENV !== 'production') {
        dependencies.length > 0 && checkDeps(dependencies);
    }
    React.useEffect(callback, useDeepCompareMemoize(dependencies));
}
export function useDeepCompareEffectNoCheck(callback, dependencies) {
    React.useEffect(callback, useDeepCompareMemoize(dependencies));
}
//# sourceMappingURL=useDeepCompare.js.map